import { render, staticRenderFns } from "./Reaction.vue?vue&type=template&id=4ec9f239&scoped=true&lang=pug&"
import script from "./Reaction.vue?vue&type=script&lang=js&"
export * from "./Reaction.vue?vue&type=script&lang=js&"
import style0 from "./Reaction.vue?vue&type=style&index=0&id=4ec9f239&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec9f239",
  null
  
)

export default component.exports